import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const onboardingImage1 = "/images/onboarding/onboarding-sign-up.png";
const onboardingImage2 = "/images/onboarding/onboarding-record.png";
const onboardingImage3 = "/images/onboarding/onboarding-get-paid.png";

const singleEllipseUrl = "/images/background/background-ellipse.png";
const backgroundImageUrl = "/images/background/background-app-main.png";

const onboardingSlides = [
  {
    id: 1,
    image: onboardingImage1,
    title: "Sign up in seconds",
    description: "Create your account with just an email.",
  },
  {
    id: 2,
    image: onboardingImage2,
    title: "Record your sound",
    description:
      "Use your phone to capture real-life sounds like domestic appliances, or alarms.",
  },
  {
    id: 3,
    image: onboardingImage3,
    title: "Get paid fast",
    description:
      "Earn up to $1 per recording. You’ll be paid immediately after your work has been completed and reviewed.",
  },
];

export function AuthOnboarding() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  const handleNext = () => {
    if (currentSlide < onboardingSlides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      navigate("/signup");
    }
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const activeSlide = onboardingSlides[currentSlide];

  return (
    <div
      className="h-screen bg-cover bg-center overflow-hidden pt-20"
      style={{
        backgroundImage: `url(${backgroundImageUrl})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      {/* Single Top Ellipse Element */}
      <div
        className="w-full h-full"
        style={{
          backgroundImage: `url(${singleEllipseUrl})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPositionY: "0% 0%",
          backgroundPositionX: "center",
        }}
      >
        <div className="flex flex-col items-center justify-between flex-grow h-full px-8 pt-[2rem] pb-40">
          <div className="flex flex-col items-center text-center">
            <h2 className="text-lg font-medium mb-2 text-gray-800 tracking-normal">
              {activeSlide.title}
            </h2>
            <p className="text-xs font-normal text-gray-800 max-w-xs leading-snug tracking-wide mb-10">
              {activeSlide.description}
            </p>
            <img
              src={activeSlide.image}
              alt={activeSlide.title}
              className="w-96 h-72 object-contain mb-8"
            />
            {/* Navigation Dots */}
            <div className="flex justify-center space-x-2 mb-10">
              {onboardingSlides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  className={`w-2.5 h-2.5 rounded-full transition-colors duration-200 ${
                    index === currentSlide
                      ? "bg-red-600"
                      : "bg-gray-300 hover:bg-gray-400"
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
          {/* Action Area */}
          <div className="w-full max-w-xs">
            <button
              onClick={handleNext}
              className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-4 rounded-full transition duration-200 mb-4 shadow-md"
            >
              {currentSlide === onboardingSlides.length - 1
                ? "Sign up"
                : "Next"}
            </button>
            <div className="text-center">
              <span className="text-gray-800">Already have an account? </span>
              <Link
                to="/login"
                className="text-red-500 hover:text-red-400 font-semibold"
              >
                Login
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom Ellipse */}
      {/*<div className="absolute bottom-0 left-0 w-full h-auto z-0">*/}
      {/*  <img*/}
      {/*    src={singleEllipseUrl}*/}
      {/*    alt="Bottom Shape"*/}
      {/*    className="w-full h-auto object-cover"*/}
      {/*    style={{ transform: "rotate(180deg)" }}*/}
      {/*  />*/}
      {/*</div>*/}
      {/* Content Area */}
    </div>
  );
}
